<template>
  <div
    class="flex w-full items-center justify-center min-h-screen px-6"
    :class="$style.layout">
    <div class="max-w-2xl w-full mx-auto">
      <template v-if="!isRedirecting">
        <div class="text-2xl font-semibold text-center mb-10">
          Accede a tu contenido
        </div>

        <XInput
          label="Nombre"
          v-model="firstName"
          :class="$style['input-max-size']"
          v-validate="'required'"
          data-vv-name="firstName"
          :invalid="validationHasErrors('firstName')"
        />

        <div
          v-if="validationHasErrors('firstName')"
          class="text-xs text-danger-40 text-center mt-3">
          {{ validationErrors('firstName')[0] }}
        </div>

        <XInput
          label="Apellidos"
          v-model="lastName"
          class="mt-3"
          :class="$style['input-max-size']"
          v-validate="'required'"
          data-vv-name="lastName"
          :invalid="validationHasErrors('lastName')"
        />

        <div
          v-if="validationHasErrors('lastName')"
          class="text-xs text-danger-40 text-center mt-3">
          {{ validationErrors('lastName')[0] }}
        </div>

        <div
          v-if="searchAttendeeTimeline === null"
          class="text-xs text-danger-40 text-center mt-3">
          No hay ningún asistente registrado con este nombre
        </div>

        <div
          v-if="errorMessage"
          class="text-xs text-danger-40 text-center mt-3">
          {{ errorMessage }}
        </div>

        <div class="text-center">
          <XButton
            class="mt-3"
            color="primary"
            :loading="loading"
            @click="onSubmit"
          >
            Buscar
          </XButton>
        </div>
      </template>

      <XSpinner
        v-else
        class="text-4xl" />
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { mapState } from 'vuex'

import FormValidation from '@common/mixins/FormValidation'

export default {
  mixins: [FormValidation],

  data () {
    return {
      firstName: '',
      lastName: '',
      validationLoading: false,
      isValid: false,
      searchAttendeeTimeline: '',
      isRedirecting: false,
      errorMessage: ''
    }
  },

  computed: {
    ...mapState({
      eventId: state => state.routeParameters.event.id
    }),

    fullName () {
      return this.firstName + ' ' + this.lastName
    },

    loading () {
      return this.validationLoading || this.$apollo.queries.searchAttendeeTimeline.loading
    }
  },

  apollo: {
    searchAttendeeTimeline: {
      query: gql`query ($eventId: Uuid!, $value: String!) {
        event (eventId: $eventId) {
          searchAttendeeTimeline (value: $value)
        }
      }`,
      variables () {
        return {
          eventId: this.eventId,
          value: this.fullName
        }
      },
      skip: function () {
        return !this.isValid
      },
      update (data) {
        return data.event.searchAttendeeTimeline
      },
      result (result) {
        this.isValid = false

        if (result.data.event.searchAttendeeTimeline) {
          window.location = result.data.event.searchAttendeeTimeline

          this.isRedirecting = true
        }
      },
      error () {
        this.errorMessage = 'Ha ocurrido un error en la comprobación. Intentelo de nuevo más tarde'
      }
    }
  },

  methods: {
    onSubmit () {
      if (this.loading) {
        return
      }

      this.validationLoading = true

      this.validate()
        .then(isValid => {
          if (!isValid) {
            return
          }

          if (this.isValid) {
            this.$apollo.queries.searchAttendeeTimeline.refresh()
          }

          this.isValid = true
        })
        .finally(() => {
          this.validationLoading = false
        })
    }
  }
}
</script>

<style module>
.layout {
  background-color: rgb(248, 249, 255);
}

.input-max-size {
  max-width: 500px;
  margin: 0 auto;
}
</style>
